import React from "react";
import { INFORMATIONAL_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT } from "../theme";
import InformationIcon from "../icons/InformationIcon";
import Popup, { PopupProps } from "./Popup";

const WarningPopup: React.FC<PopupProps> = (props) => {
  return (
    <Popup
      backgroundColor={
        props.backgroundColor ??
        INFORMATIONAL_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT
      }
      icon={props.icon ?? <InformationIcon />}
      {...props}
    />
  );
};

export default WarningPopup;
